import { createContext, useContext, type ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

const NotchToastIconContext = createContext<ReactNode>(null)

export function NotchToastIconProvider({ icon, children }: { icon?: ReactNode; children: ReactNode }) {
  return <NotchToastIconContext.Provider value={icon ?? null}>{children}</NotchToastIconContext.Provider>
}

export function useNotchToastIcon(): ReactNode {
  return useContext(NotchToastIconContext)
}

/** The icon passed to `toast.add`, available inside a notch body. */
export function NotchToastIcon({ className }: { className?: string }) {
  const icon = useNotchToastIcon()
  if (!icon) {
    return null
  }

  return <div className={twMerge('shrink-0', className)}>{icon}</div>
}
